// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"ec159d1d","184":"9eefaa5f"}[chunkId] + ".chunk.js";
};